const environments = {
    local: 'https://localhost:7068/api',
    dev: 'http://localhost:8080/api',
    uat: 'https://aclregistry.isakos.com:8443/api',
  };

  // Change this to switch environment
  // const ENVIRONMENT = 'uat'; 
  const ENVIRONMENT = 'uat'; 
  
  export const BASE_URL = environments[ENVIRONMENT];
  